import { keyframes } from "@emotion/react";
import { Box } from "@mui/material";
import type { FC } from "react";
import { Logo } from "./logo";

const bounce1 = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 1px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
    transform-origin: 19px 17.5px;
  }
  100% {
    transform: rotate(360deg);
    transform-origin: 19px 17.5px;
  }
`;

export const SplashScreen: FC = () => (
  <Box
    sx={{
      alignItems: "center",
      backgroundColor: "neutral.900",
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      left: 0,
      p: 3,
      position: "fixed",
      top: 0,
      width: "100vw",
      zIndex: 2000,
    }}
  >
    <Logo
      variant="light"
      sx={{
        height: 62,
        "& g": {
          animation: `${rotate} 1s ease-in-out infinite`,
        },
        // "& path:nth-child(3)": {
        //   animation: `${bounce3} 1s ease-in-out infinite`,
        // },
      }}
    />
  </Box>
);
